import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { Twitter, Linkedin, Instagram, Mail } from "lucide-react";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_neural-growth-5/artifacts/ui6txxdc_EM%20Logo2.png";

const footerLinks = {
  Company: [
    { name: "About", path: "/about" },
    { name: "Services", path: "/services" },
    { name: "Contact", path: "/contact" },
  ],
  Services: [
    { name: "Content Creation", path: "/services" },
    { name: "SEO Consultancy", path: "/services" },
    { name: "GEO/AEO Consultancy", path: "/services" },
    { name: "LinkedIn Marketing", path: "/services" },
  ],
  Legal: [
    { name: "Privacy Policy", path: "/" },
    { name: "Terms of Service", path: "/" },
  ],
};

const socials = [
  { icon: Twitter, label: "Twitter", href: "#" },
  { icon: Linkedin, label: "LinkedIn", href: "#" },
  { icon: Instagram, label: "Instagram", href: "#" },
  { icon: Mail, label: "Email", href: "mailto:hello@engeniusmarketing.com" },
];

const Footer = () => {
  return (
    <motion.footer
      data-testid="footer"
      initial={{ opacity: 0 }}
      whileInView={{ opacity: 1 }}
      viewport={{ once: true }}
      transition={{ duration: 0.7 }}
      style={{
        background: "#080810",
        borderTop: "1px solid rgba(255,255,255,0.06)",
      }}
    >
      <div className="container-custom py-16">
        <div className="grid grid-cols-1 md:grid-cols-5 gap-10 md:gap-8">
          {/* Brand */}
          <div className="md:col-span-2">
            <Link to="/" className="flex items-center mb-4" data-testid="footer-logo">
              <img
                src={LOGO_URL}
                alt="EnGenius Marketing"
                style={{ height: "52px", width: "auto" }}
              />
            </Link>
            <p className="text-sm leading-relaxed mb-6 max-w-xs" style={{ color: "#71717a" }}>
              AI-powered marketing that delivers measurable growth. We engineer strategies that scale, using the latest in artificial intelligence.
            </p>
            <div className="flex items-center gap-3">
              {socials.map(({ icon: Icon, label, href }) => (
                <motion.a
                  key={label}
                  href={href}
                  data-testid={`footer-social-${label.toLowerCase()}`}
                  aria-label={label}
                  whileHover={{ scale: 1.15, y: -2 }}
                  whileTap={{ scale: 0.95 }}
                  className="w-9 h-9 rounded-lg flex items-center justify-center transition-all"
                  style={{
                    background: "rgba(255,255,255,0.05)",
                    border: "1px solid rgba(255,255,255,0.08)",
                    color: "#a1a1aa",
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.borderColor = "rgba(79,142,247,0.4)";
                    e.currentTarget.style.color = "#4F8EF7";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.borderColor = "rgba(255,255,255,0.08)";
                    e.currentTarget.style.color = "#a1a1aa";
                  }}
                >
                  <Icon size={16} />
                </motion.a>
              ))}
            </div>
          </div>

          {/* Links */}
          {Object.entries(footerLinks).map(([category, links]) => (
            <div key={category}>
              <h4 className="font-heading font-semibold text-white text-sm mb-4 tracking-wide uppercase" style={{ letterSpacing: "0.08em" }}>
                {category}
              </h4>
              <ul className="space-y-3">
                {links.map((link) => (
                  <li key={link.name}>
                    <Link
                      to={link.path}
                      data-testid={`footer-link-${link.name.toLowerCase().replace(/\s+/g, '-')}`}
                      className="text-sm transition-colors duration-200"
                      style={{ color: "#71717a" }}
                      onMouseEnter={(e) => (e.target.style.color = "#a1a1aa")}
                      onMouseLeave={(e) => (e.target.style.color = "#71717a")}
                    >
                      {link.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* Bottom bar */}
        <div
          className="mt-12 pt-6 flex flex-col md:flex-row items-center justify-between gap-4"
          style={{ borderTop: "1px solid rgba(255,255,255,0.06)" }}
        >
          <p className="text-xs" style={{ color: "#52525b" }}>
            &copy; {new Date().getFullYear()} EnGenius Marketing. All rights reserved.
          </p>
          <p className="text-xs" style={{ color: "#52525b" }}>
            engeniusmarketing.com
          </p>
        </div>
      </div>
    </motion.footer>
  );
};

export default Footer;
